module.exports = __webpack_public_path__ + "media/images/sp/items/gift/kiribako_04_thumb-4ed5fc6ad5d1ef31f0d29179fdb0aa34.jpg";